export const BASENAME = process.env.REACT_APP_BASENAME || '/Egen-Insamling';


